/**
 * Injeção estrita num shader do three (F118): o código entra antes ou depois de `#include <chunk>`, que
 * precisa aparecer exatamente uma vez. Um chunk renomeado ou repetido numa versão nova do three lança
 * erro com o nome dele, em vez de compilar um material quebrado em silêncio.
 */
export function injectAtChunk(source: string, chunk: string, code: string, where: "before" | "after"): string {
  const include = `#include <${chunk}>`;
  const first = source.indexOf(include);
  if (first < 0) throw new Error(`superfície dos atores: o shader não tem ${include}`);
  if (source.indexOf(include, first + include.length) >= 0) throw new Error(`superfície dos atores: ${include} aparece mais de uma vez`);
  return where === "before" ? `${source.slice(0, first)}${code}\n${source.slice(first)}` : `${source.slice(0, first + include.length)}\n${code}${source.slice(first + include.length)}`;
}
